import { catalogFields } from './catalogRow';
import { findHeaderRowIndex } from './headers';
import { parseSpaMetadata } from './parseSpaMetadata';
import type { EatonPriceRow } from './types';

/** Catalogue lines from one INTO-STOCK SPA tab. */
export function parseSpaPriceSheet(
  rows: unknown[][],
  fileName: string,
  sourceSheet: string,
): EatonPriceRow[] {
  const headerIndex = findHeaderRowIndex(rows, 'CATALOGUE');
  if (headerIndex < 0) return [];
  const header = rows[headerIndex];
  if (!header) return [];
  const meta = parseSpaMetadata(rows.slice(0, headerIndex), sourceSheet);
  if (meta.spaId === '') return [];
  const prices: EatonPriceRow[] = [];
  for (const row of rows.slice(headerIndex + 1)) {
    const fields = catalogFields(header, row);
    if (fields.catalog === '') continue;
    prices.push({
      fileName,
      sourceSheet,
      spaId: meta.spaId,
      spaDescription: meta.spaDescription,
      region: meta.region,
      ...fields,
      location: '',
      customerCount: 0,
      coverageRegions: meta.region,
    });
  }
  return prices;
}
